import { Component, Vue } from "vue-property-decorator";
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import Model from "@/models/Model";
import VModal from 'vue-js-modal'

import 'vue2-datepicker/index.css';
import { GET_LOG_REQUEST, RETRY_OUTSTANDING } from "../../../api/log-request";

Vue.use(VModal, { componentName: 'modal' })
@Component({
    components: {
        DatePicker
    },
    filters: {
        currency(value: any) {
            const val = (value / 1).toFixed(2).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        dateTime(val: any) {
            return val ? moment(val).local().format('DD-MM-YYYY HH:mm:ss') : ''
        }
    }
})
default class Retry extends Vue {
    $axios: any;
    private model: Model;
    private retryData: any = []
    public dateFilter = {
        startDate: moment().local().startOf('day').toDate(),
        endDate: moment().local().endOf('day').toDate()
    }

    private paginate = {
        page: 1,
        limit: 10
    }
    private pageSize = 0;
    private paginateShow = false;
    private dataLoading = false;
    private filterGameId = ""
    private jsonString = ""

    constructor() {
        super();
        this.model = new Model();
    }

    async mounted() {

        this.addRouteName()
        this.dataLoading = true
        await this.getLogRequest(this.paginate.page, this.paginate.limit)
        this.dataLoading = false
    }

    private addRouteName() {
        this.model.Name = this.$route.name;
        this.$store
            .dispatch("addRouteName", this.model)
    }

    public async filterRetryData() {
        this.paginate.page = 1
        await this.getLogRequest(this.paginate.page, this.paginate.limit)
    }

    public async openModal(field: string, json: string) {
        if (field == 'retry') {
        this.jsonString = json
        this.$modal.show('modalRequest');
        }
    }

    public hide(field: string) {
        if (field == 'retry') {
            this.$modal.hide('modalRequest');
        }
    }

    public async selectDate(option: string) {
        switch (option) {
            case 'option1':
                this.dateFilter.startDate = moment(this.dateFilter.startDate).subtract(1, 'days').toDate()
                this.dateFilter.endDate = moment(this.dateFilter.endDate).subtract(1, 'days').toDate()
                break;
            case 'option2':
                this.dateFilter.startDate = moment().local().startOf('day').toDate()
                this.dateFilter.endDate = moment().local().endOf('day').toDate()
                break;
            case 'option3':
                this.dateFilter.startDate = moment().local(true).startOf('day').subtract(1, 'days').toDate()
                this.dateFilter.endDate = moment().local(true).endOf('day').subtract(1, 'days').toDate()
                break;
            case 'option4':
                this.dateFilter.startDate = moment().local(true).startOf('week').toDate()
                this.dateFilter.endDate = moment().local(true).endOf('week').toDate()
                break;
            case 'option5':
                this.dateFilter.startDate = moment().local(true).subtract(1, 'week').startOf('week').toDate()
                this.dateFilter.endDate = moment().local(true).subtract(1, 'week').endOf('week').toDate()
                break;
            case 'option6':
                this.dateFilter.startDate = moment().local(true).startOf('month').toDate()
                this.dateFilter.endDate = moment().local(true).endOf('month').toDate()
                break;
            case 'option7':
                this.dateFilter.startDate = moment().local(true).subtract(1, 'months').startOf('month').toDate()
                this.dateFilter.endDate = moment().local(true).subtract(1, 'months').endOf('month').toDate()
                break;
            case 'option8':
                this.dateFilter.startDate = moment(this.dateFilter.startDate).add(1, 'days').toDate()
                this.dateFilter.endDate = moment(this.dateFilter.endDate).add(1, 'days').toDate()
                break;
            default:
                break;
        }
        await this.getLogRequest(this.paginate.page, this.paginate.limit)
    }

    public async retryFn(gameId) {
        const loader = this.$loading.show({
            color: '#CFA137',
            loader: 'spinner',
            width: 145,
            height: 235,
            backgroundColor: '#000000',
            opacity: 0.5,
        });

        const state = {
            gameId : gameId,
            method : "re-settle"
        }

        await RETRY_OUTSTANDING(state)

        await this.getLogRequest(this.paginate.page, this.paginate.limit)

        loader.hide()


    }

    public async reSendSettle(gameId) {
        const loader = this.$loading.show({
            color: '#CFA137',
            loader: 'spinner',
            width: 145,
            height: 235,
            backgroundColor: '#000000',
            opacity: 0.5,
        });

        const state = {
            gameId : gameId,
            method : "re-send-settle"
        }

        await RETRY_OUTSTANDING(state)

        await this.getLogRequest(this.paginate.page, this.paginate.limit)

        loader.hide()


    }

    public async clickCallback(number: number) {
        this.paginate.page = number
        await this.getLogRequest(this.paginate.page, this.paginate.limit)
    }

    private async getLogRequest(page: number, limit: number) {
        this.retryData = []
        const loader = this.$loading.show({
            color: '#CFA137',
            loader: 'spinner',
            width: 145,
            height: 235,
            backgroundColor: '#000000',
            opacity: 0.5,
        });
        const lists = await GET_LOG_REQUEST(this.filterGameId, (this.dateFilter.startDate).toISOString(), (this.dateFilter.endDate).toISOString(),page, limit)
        this.retryData = lists.data[0];

        if (this.retryData.metadata.length >= 1) {
            const num = (this.paginate.page * this.paginate.limit)
            for (let i = 0, k = num; i < this.retryData.metadata.length; i++, k++) {
                this.retryData.metadata[i].no = k - this.paginate.limit
            }
            if (this.retryData.pageInfo[0].count > this.paginate.limit) {
                this.paginateShow = true
            }
            this.pageSize = this.retryData.pageInfo[0].size;
        } else {
            this.retryData = []
            this.paginateShow = false
        }
        loader.hide()
    }
}

export default Retry